import { observable, action } from 'mobx'
import { has } from 'lodash'

export type IScriptPagination = {
  take: number
  skip: number
}

export const DEFAULT_PAGE_SIZE = 100

class ScriptPagination {
  @observable take: IScriptPagination['take']
  @observable skip: IScriptPagination['skip']

  constructor(pagination: IScriptPagination) {
    this.take = pagination.take
    this.skip = pagination.skip
  }

  @action
  update(pagination: Partial<IScriptPagination> = {}) {
    has(pagination, 'take') && (this.take = pagination.take!)
    has(pagination, 'skip') && (this.skip = pagination.skip!)
  }

  @action
  reset() {
    this.update({
      take: 100,
      skip: 0,
    })
  }
}

export default ScriptPagination
